import React from 'react';
import ProductRecommendations from './ProductRecommendations.js';

function ResultsDisplay({ analysis, image, onReset }) {
  if (analysis.error) {
    return (
      <div className="results error">
        <h2>⚠️ Analysis Error</h2>
        <p>{analysis.error}</p>
        <button onClick={onReset} className="btn-primary">Try Another Photo</button>
      </div>
    );
  }

  return (
    <div className="results">
      <div className="result-header">
        <h2>Your Analysis Results</h2>
        <div className="confidence-badge">
          {analysis.confidence === 'high' ? '✓ High Confidence' : 'Medium Confidence'}
        </div>
      </div>

      <div className="result-image">
        <img src={image} alt="Your analyzed face" className="analyzed-photo" />
      </div>

      <div className="analysis-grid">
        <div className="analysis-card primary">
          <h3>Face Shape</h3>
          <div className="shape-name">{analysis.faceShape}</div>
          <p>{analysis.characteristics}</p>
        </div>

        <div className="analysis-card">
          <h3>Skin Undertone</h3>
          <div className="tone-name">{analysis.skinTone}</div>
          <p>Determined by analyzing color sampling from your photo</p>
        </div>
      </div>

      <div className="recommendations">
        <h3>💇 Recommended Hairstyles for You</h3>
        <div className="style-tags">
          {analysis.recommendations.faceShape.hairstyles.map((style, idx) => (
            <span key={idx} className="style-tag recommended">{style}</span>
          ))}
        </div>
        
        <div className="why-section">
          <h4>Why These Work:</h4>
          <p>{analysis.recommendations.faceShape.why}</p>
        </div>

        <div className="avoid-section">
          <h4>Styles to Avoid:</h4>
          <p>{analysis.recommendations.faceShape.avoid.join(', ')}</p>
        </div>
      </div>

      <div className="color-recommendations">
        <h3>🎨 Recommended Hair Colors</h3>
        <div className="color-palette">
          {analysis.recommendations.skinTone.palette.map((color, idx) => (
            <div key={idx} className="color-swatch">{color}</div>
          ))}
        </div>
        <div className="why-section" style={{marginTop: '20px'}}>
          <h4>Color Guidance:</h4>
          <p>{analysis.recommendations.skinTone.why}</p>
        </div>
      </div>

      <ProductRecommendations 
        faceShape={analysis.faceShape} 
        skinTone={analysis.skinTone}
      />

      <div className="actions">
        <button onClick={onReset} className="btn-secondary">Analyze Another Photo</button>
        <button className="btn-primary" onClick={() => alert('Premium feature coming soon!')}>
          Save Full Report (Free)
        </button>
      </div>

      <div className="share-section">
        <p>Love your results? Share with friends!</p>
        <div className="share-buttons">
          <button className="share-btn" onClick={() => {
            const text = `I discovered I have a ${analysis.faceShape} face shape! Find yours at`;
            const url = window.location.href;
            window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`, '_blank');
          }}>
            Share on X/Twitter
          </button>
          <button className="share-btn" onClick={() => {
            alert('Screenshot your results and share on TikTok/Instagram with #FaceAndStyle!');
          }}>
            Share on TikTok
          </button>
        </div>
      </div>
    </div>
  );
}

export default ResultsDisplay;